<template>
  <div v-if="visible" class="cm-overlay" @click.self="$emit('close')">
    <div class="cm-modal" role="dialog" aria-modal="true" aria-label="Share QR">
      <div class="cm-header d-flex align-items-center justify-content-between">
        <h6 class="mb-0">Share via QR Code</h6>
        <button class="cm-close" @click="$emit('close')" aria-label="Close">×</button>
      </div>

      <div class="cm-body text-center">
        <div v-if="qrSrc">
          <img v-no-right-click :src="qrSrc" alt="Event QR code" class="qr-img mb-2" />
        </div>
        <div v-else class="text-muted small">No QR available.</div>

        <div class="input-group mt-3">
          <input type="text" class="form-control form-control-sm" :value="url" readonly />
          <div class="input-group-append">
            <button class="btn btn-outline-secondary btn-sm" @click="copyLink">
              <i class="far fa-copy"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="cm-footer d-flex justify-content-end">
        <button class="btn btn-secondary btn-sm" @click="$emit('close')">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

export default defineComponent({
  name: 'QrShareModal',
  props: {
    visible: { type: Boolean, default: false },
    qrSrc: { type: String, default: '' },
    url: { type: String, default: '' }
  },
  emits: ['close'],
  setup(props) {
    const toast = (icon, title) => {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon,
        title,
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
    };

    async function copyLink() {
      try {
        await navigator.clipboard.writeText(props.url || window.location.href);
        toast("success", "Link copied!");
      } catch {
        toast("error", "Could not copy. Please copy manually.");
      }
    }

    return { copyLink };
  }
});
</script>


<style scoped>
.cm-overlay{
  position: fixed; inset: 0; background: rgba(0,0,0,.45);
  display: flex; align-items: center; justify-content: center; z-index: 1060;
}
.cm-modal{
  width: 100%; max-width: 420px; background: #fff; border-radius: .5rem;
  box-shadow: 0 10px 30px rgba(0,0,0,.2); overflow: hidden;
}
.cm-header, .cm-footer{ padding: .75rem 1rem; background: #f8f9fa; }
.cm-body{ padding: 1rem; }
.cm-close{ border: 0; background: transparent; font-size: 1.25rem; line-height: 1; }
.qr-img{ width: 260px; height: 260px; object-fit: contain; }
</style>
